/** Le due rotte dell'impostazione `inPlaceEditing` (apps/gateway/src/routes/inplace.ts). */
import type { WriteResult } from '@cms/contracts'
import { apiFetch } from './client.js'
import type { WriteEnvelope } from './endpoints.js'
import type { InPlaceSettings } from '../domain/in-place-edit.js'

export interface InPlaceSettingsRead extends InPlaceSettings {
  siteId: string
  version: number
}

export function getInPlaceSettings(siteId: string): Promise<InPlaceSettingsRead> {
  return apiFetch(`/sites/${encodeURIComponent(siteId)}/inplace`)
}

export function setInPlaceSettings(
  siteId: string,
  body: WriteEnvelope & { enabled: boolean; allowedHosts: string[] },
  idempotencyKey: string,
): Promise<WriteResult> {
  return apiFetch(`/sites/${encodeURIComponent(siteId)}/inplace`, { method: 'PUT', body, idempotencyKey })
}
